import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-standard-stone-pricing',
    templateUrl: './standard-stone-pricing.component.html',
    styleUrls: ['./standard-stone-pricing.component.scss']
})
export class StandardStonePricingComponent implements OnInit {
    @Input() costGroups = [];

    activeCostGroup;

    costs = []

    constructor() { }

    ngOnInit(): void {
        this.setCostGroup(0)
        if (!this.costGroups.length) {
            this.costGroups = [
                { id: 'small', name: 'Small', costs: [] },
                { id: 'medium', name: 'Medium', costs: [] },
                { id: 'large', name: 'Large', costs: [] },
            ]
        }
    }

    setCostGroup(idx) {
        if (this.activeCostGroup) {
            this.save();
        }
        this.activeCostGroup = this.costGroups[idx];
    }

    save() {
        for (let i = 0; i < this.costGroups.length; i++) {
            if (this.costGroups[i].id === this.activeCostGroup.id) {
                this.costGroups[i] = this.activeCostGroup;
            }
        }
    }

    remove(idx) {
        this.activeCostGroup.costs.splice(idx, 1);
        this.save();
    }

    add() {
        const newCost = {
            minQty: 0,
            maxQty: 0,
            cost: 0,
        }
        this.activeCostGroup.costs.push(newCost);
        this.save();
    }

}
